import React from 'react';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import { ThemeProvider } from '@material-ui/core/styles';
import Theme from '../theme/CustomTheme'
import { Button, Grid, Checkbox } from '@material-ui/core';
import useStyles from '../styles/CustomStyle';
import "../styles/MuiCustom.css"
import "../styles/ResponsiveStyle.css"
import BankInformation from "./BankInformaton"
import PersonalInformation from "./PersonalInformation"
import DrivingLicenseInformation from './DrivingLicenseInformation';
import VehicleInformation from './VehicleInformation';

export default function AdditionalInformationWrapper(props) {
  const classes = useStyles();

  let rePhone = /^(?:\+?88)?01[3-9]\d{8}$/

  const [expanded, setExpanded] = React.useState({
    personalInfo: false,
    drivingLicenseInfo: false,
    vehicleInfo: false,
    bankInfo: false
  })

  const [checked, setChecked] = React.useState(false);
  const [error, setError] = React.useState({
    car_type: false,
    vehicle_identification_no: false,
    vehicle_year: false,
    vehicle_registration_year: false,
    vehicle_make: false,
    vehicle_model: false,
    registeredOwnerName: false,
    registeredOwnerphone: {
      isEmpty: false,
      invalid: false
    },
    nid_no: false,
    driver_license_no: false,
    driver_license_exp: false,
    license_expiry_date: false,

    license_plate_no: {
      isEmpty: false,
      invalid: false
    },
    license_plate_district: false,
    license_plate_series: false,

    account_holder_name: false,
    bank_account_number: false,
    bank_name: false,
    branch_name: false,
    bkash_id: {
      isEmpty: false,
      invalid: false
    },
    rocket_id: {
      isEmpty: false,
      invalid: false
    },
    nagad_id: {
      isEmpty: false,
      invalid: false
    }
  })

  const handleCheck = () => {
    setChecked(!checked)
  }

  const handleValidate = (e) => {
    e.preventDefault();
    if (!props.stepContent.driver_photo.file) {
      setExpanded({
        bankInfo: false,
        vehicleInfo: false,
        drivingLicenseInfo: false,
        personalInfo: true
      })
      alert("Driver photo not found")

    } else if (!props.stepContent.driver_nid_passport_front.file) {
      setExpanded({
        bankInfo: false,
        vehicleInfo: false,
        drivingLicenseInfo: false,
        personalInfo: true
      })
      alert("Driver NID photo (Front) not found")

    } else if (!props.stepContent.driver_nid_passport_back.file) {
      setExpanded({
        bankInfo: false,
        vehicleInfo: false,
        drivingLicenseInfo: false,
        personalInfo: true
      })
      alert("Driver NID photo (Back) not found")

    } else if (!props.stepContent.nid_no) {
      setExpanded({
        bankInfo: false,
        vehicleInfo: false,
        drivingLicenseInfo: false,
        personalInfo: true
      })
      setError({
        ...error,
        nid_no: true
      });

    } else if (!props.stepContent.date_of_birth) {
      setExpanded({
        bankInfo: false,
        vehicleInfo: false,
        drivingLicenseInfo: false,
        personalInfo: true
      })
      setError({
        ...error,
        date_of_birth: true
      });

    } else if (!props.stepContent.driving_license_front.file) {
      setExpanded({
        bankInfo: false,
        vehicleInfo: false,
        personalInfo: false,
        drivingLicenseInfo: true
      })
      alert("Driver license photo (Front) not found")
    } else if (!props.stepContent.driving_license_back.file) {
      setExpanded({
        bankInfo: false,
        vehicleInfo: false,
        personalInfo: false,
        drivingLicenseInfo: true
      })
      alert("Driver license photo (Back) not found")
    } else if (!props.stepContent.driver_license_no) {
      setExpanded({
        bankInfo: false,
        vehicleInfo: false,
        personalInfo: false,
        drivingLicenseInfo: true
      })
      setError({
        ...error,
        driver_license_no: true
      });
    } else if (!props.stepContent.driver_license_exp) {
      setExpanded({
        bankInfo: false,
        vehicleInfo: false,
        personalInfo: false,
        drivingLicenseInfo: true
      })
      setError({
        ...error,
        driver_license_exp: true
      });
    }
    else if (!props.stepContent.driving_license_back.file) {
      setExpanded({
        bankInfo: false,
        vehicleInfo: false,
        personalInfo: false,
        drivingLicenseInfo: true
      })
      alert("Driver license photo (Back) not found")
    } else if (props.stepContent.car_type === "") {
      setExpanded({
        bankInfo: false,
        personalInfo: false,
        drivingLicenseInfo: false,
        vehicleInfo: true
      })
      setError({
        ...error,
        car_type: true
      });
    } else if (!props.stepContent.vehicle_identification_no) {
      setExpanded({
        bankInfo: false,
        personalInfo: false,
        drivingLicenseInfo: false,
        vehicleInfo: true
      })
      setError({
        ...error,
        vehicle_identification_no: true
      });
    } else if (!props.stepContent.vehicle_registration_year) {
      setExpanded({
        bankInfo: false,
        personalInfo: false,
        drivingLicenseInfo: false,
        vehicleInfo: true
      })
      setError({
        ...error,
        vehicle_registration_year: true
      })
    } else if (!props.stepContent.vehicle_year) {
      setExpanded({
        bankInfo: false,
        personalInfo: false,
        drivingLicenseInfo: false,
        vehicleInfo: true
      })
      setError({
        ...error,
        vehicle_year: true
      });
    } else if (!props.stepContent.vehicle_make) {
      setExpanded({
        bankInfo: false,
        personalInfo: false,
        drivingLicenseInfo: false,
        vehicleInfo: true
      })
      setError({
        ...error,
        vehicle_make: true
      });
    } else if (!props.stepContent.vehicle_model) {
      setExpanded({
        bankInfo: false,
        personalInfo: false,
        drivingLicenseInfo: false,
        vehicleInfo: true
      })
      setError({
        ...error,
        vehicle_model: true
      });
    } else if (!props.stepContent.license_plate_district) {
      setExpanded({
        bankInfo: false,
        personalInfo: false,
        drivingLicenseInfo: false,
        vehicleInfo: true
      })
      setError({
        ...error,
        license_plate_district: true
      });
    } else if (!props.stepContent.license_plate_series) {
      setExpanded({
        bankInfo: false,
        personalInfo: false,
        drivingLicenseInfo: false,
        vehicleInfo: true
      })
      setError({
        ...error,
        license_plate_series: true
      });
    } else if (!props.stepContent.license_plate_no) {
      setExpanded({
        bankInfo: false,
        personalInfo: false,
        drivingLicenseInfo: false,
        vehicleInfo: true
      })
      setError({
        ...error,
        license_plate_no: {
          isEmpty: true
        }
      });
    } else if (!props.stepContent.driving_registration_front.file) {
      setExpanded({
        bankInfo: false,
        personalInfo: false,
        drivingLicenseInfo: false,
        vehicleInfo: true
      })
      alert("Vehicle registration photo not found")
    }
    // else if (!props.stepContent.driving_registration_back.file) {
    //   setExpanded({
    //     bankInfo: false,
    //     personalInfo: false,
    //     drivingLicenseInfo: false,
    //     vehicleInfo: true
    //   })
    //   alert("Vehicle registration photo (Back) not found")
    // } 
    else if (!props.bankType) {
      setExpanded({
        personalInfo: false,
        vehicleInfo: false,
        drivingLicenseInfo: false,
        bankInfo: true
      })
      alert("Bank Information required")
    } else if (props.bankType === "Bank") {
      if (!props.stepContent.account_holder_name) {
        setExpanded({
          personalInfo: false,
          vehicleInfo: false,
          drivingLicenseInfo: false,
          bankInfo: true
        })
        setError({
          ...error,
          account_holder_name: true
        });

      } else if (!props.stepContent.bank_account_number) {
        setExpanded({
          personalInfo: false,
          vehicleInfo: false,
          drivingLicenseInfo: false,
          bankInfo: true
        })
        setError({
          ...error,
          bank_account_number: true
        });
      } else if (!props.stepContent.bank_name) {
        setExpanded({
          personalInfo: false,
          vehicleInfo: false,
          drivingLicenseInfo: false,
          bankInfo: true
        })
        setError({
          ...error,
          bank_name: true
        });
      } else if (!props.stepContent.branch_name) {
        setExpanded({
          personalInfo: false,
          vehicleInfo: false,
          drivingLicenseInfo: false,
          bankInfo: true
        })
        setError({
          ...error,
          branch_name: true
        });
      } else {
        // props.handleSubmit(e)
        props.handleNext();
        // props.handleSubmit();
      }
    } else if (props.bankType === "Bkash") {
      if (!props.stepContent.bkash_id) {
        setExpanded({
          personalInfo: false,
          vehicleInfo: false,
          drivingLicenseInfo: false,
          bankInfo: true
        })
        setError({
          ...error,
          bkash_id: {
            isEmpty: true
          }
        });
      } else if (!rePhone.test(props.stepContent.bkash_id)) {
        setExpanded({
          personalInfo: false,
          vehicleInfo: false,
          drivingLicenseInfo: false,
          bankInfo: true
        })
        setError({
          ...error,
          bkash_id: {
            invalid: true
          }
        });

      } else {
        props.handleNext();
        // props.handleSubmit();


      }
    } else if (props.bankType === "Rocket") {
      if (!props.stepContent.rocket_id) {
        setExpanded({
          personalInfo: false,
          vehicleInfo: false,
          drivingLicenseInfo: false,
          bankInfo: true
        })
        setError({
          ...error,
          rocket_id: {
            isEmpty: true
          }
        });
      } else if (!rePhone.test(props.stepContent.rocket_id)) {
        setExpanded({
          personalInfo: false,
          vehicleInfo: false,
          drivingLicenseInfo: false,
          bankInfo: true
        })
        setError({
          ...error,
          rocket_id: {
            invalid: true
          }
        });

      } else {
        props.handleNext();
        // props.handleSubmit();
      }
    } else if (props.bankType === "Nagad") {
      if (!props.stepContent.nagad_id) {
        setExpanded({
          personalInfo: false,
          vehicleInfo: false,
          drivingLicenseInfo: false,
          bankInfo: true
        })
        setError({
          ...error,
          nagad_id: {
            isEmpty: true
          }
        });
      } else if (!rePhone.test(props.stepContent.nagad_id)) {
        setExpanded({
          personalInfo: false,
          vehicleInfo: false,
          drivingLicenseInfo: false,
          bankInfo: true
        })
        setError({
          ...error,
          nagad_id: {
            invalid: true
          }
        });

      } else {
        props.handleNext();
        // props.handleSubmit();
      }
    }
    else {
      props.handleNext();
      // props.handleSubmit();

    }
  }

  return (
    <React.Fragment>
      <Typography variant="h4" gutterBottom className="title" style={{ textAlign: "center", padding: "10px 0 20px 0" }}>
        Additional Information
      </Typography>
      <form>
        <ThemeProvider theme={Theme}>
          <ExpansionPanel expanded={expanded.personalInfo} onChange={() => setExpanded({
            personalInfo: !expanded.personalInfo,
            bankInfo: false,
            vehicleInfo: false,
            drivingLicenseInfo: false
          })}>
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="vehicle-information"
            >
              <Typography className={classes.heading}>Personal Information</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <PersonalInformation stepContent={props.stepContent} handleChange={props.handleChange} handleSubmit={props.handleSubmit} handleBack={props.handleBack} error={error} setError={setError} />
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel expanded={expanded.drivingLicenseInfo} onChange={() => setExpanded({
            drivingLicenseInfo: !expanded.drivingLicenseInfo,
            personalInfo: false,
            bankInfo: false,
            vehicleInfo: false
          })}>
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="vehicle-information"
            >
              <Typography className={classes.heading}>Driving License Information</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <DrivingLicenseInformation stepContent={props.stepContent} handleChange={props.handleChange} handleSubmit={props.handleSubmit} handleBack={props.handleBack} error={error} setError={setError} />
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel expanded={expanded.vehicleInfo} onChange={() => setExpanded({
            vehicleInfo: !expanded.vehicleInfo,
            personalInfo: false,
            bankInfo: false,
            drivingLicenseInfo: false
          })}>
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="vehicle-information"
            >
              <Typography className={classes.heading}>Vehicle Information</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <VehicleInformation stepContent={props.stepContent} handleChange={props.handleChange} handleNext={props.handleNext} handleBack={props.handleBack} brands={props.brands} setBrands={props.setBrands} models={props.models} setModels={props.setModels} error={error} setError={setError} />
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <ExpansionPanel expanded={expanded.bankInfo} onChange={() => setExpanded({
            bankInfo: !expanded.bankInfo,
            personalInfo: false,
            vehicleInfo: false,
            drivingLicenseInfo: false
          })}>
            <ExpansionPanelSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="vehicle-information"
            >
              <Typography className={classes.heading}>Payment Information</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
              <BankInformation stepContent={props.stepContent} handleChange={props.handleChange} handleSubmit={props.handleSubmit} handleBack={props.handleBack} error={error} setError={setError} bankType={props.bankType} setBankType={props.setBankType} />
            </ExpansionPanelDetails>
          </ExpansionPanel>
          <Grid container spacing={3}>
            <Grid item xs={2} sm={1}>
              <Checkbox color='primary' name="saveCard" value="yes" onChange={handleCheck} />
            </Grid>
            <Grid item xs={10} sm={11}>
              <strong>*** <em>I hereby declare that the details stated above are true. In case any of the above information is found to be false or untrue or misleading or misrepresenting, I am aware that I will be liable for it.</em></strong>
            </Grid>
          </Grid>
          <div className={classes.buttons}>
            <Button onClick={props.handleBack} className={classes.button}>
              Back
            </Button>
            <Button
              disabled={!checked}
              variant="contained"
              color="primary"
              onClick={handleValidate}
              type="submit"
              className={classes.button}
            >
              Submit
            </Button>
          </div>
        </ThemeProvider>
      </form>
    </React.Fragment >
  );
}